export const SV_LIBRARY_HOTEL = 'SV_LIBRARY_HOTEL';
export const HOTEL_MAPPING = 'HOTEL_MAPPING';
export const HOTEL_CONTENT = 'HOTEL_CONTENT';
export const PDF_HTML = 'PDF_HTML';
export const E_DOC = 'E_DOC';
export const INVOICE = 'INVOICE';
export const ROOMING_LIST = 'ROOMING_LIST';
export const EMAIL_TEMPLATE_EN = 'EMAIL_TEMPLATE_EN';
export const EMAIL_TEMPLATE_FR = 'EMAIL_TEMPLATE_FR';
export const DEPT_TO_DEPT_EN = 'DEPT_TO_DEPT_EN';
export const EXPIRES_EN = 'EXPIRES_EN';
export const EXPIRED_EN = 'EXPIRED_EN';
export const PDF_SENT_EN = 'PDF_SENT_EN';
export const PAYMENT_IS_DUE_EN = 'PAYMENT_IS_DUE_EN';
export const NAME_REQUIRED_EN = 'NAME_REQUIRED_EN';
export const PAYMENT_SUCCESS_EN = 'PAYMENT_SUCCESS_EN';
export const DEPT_TO_DEPT_FR = 'DEPT_TO_DEPT_FR';
export const EXPIRES_FR = 'EXPIRES_FR';
export const EXPIRED_FR = 'EXPIRED_FR';
export const PDF_SENT_FR = 'PDF_SENT_FR';
export const PAYMENT_IS_DUE_FR = 'PAYMENT_IS_DUE_FR';
export const NAME_REQUIRED_FR = 'NAME_REQUIRED_FR';
export const PAYMENT_SUCCESS_FR = 'PAYMENT_SUCCESS_FR';
export const DEPOSIT_DUE_EN = 'DEPOSIT_DUE_EN';
export const DEPOSIT_DUE_FR = 'DEPOSIT_DUE_FR';
export const MISSING_MARGIN_EN = 'MISSING_MARGIN_EN';
export const MISSING_MARGIN_FR = 'MISSING_MARGIN_FR';
export const BROCHURE_URL_EN = 'BROCHURE_URL_EN';
export const BROCHURE_URL_FR = 'BROCHURE_URL_FR';
export const DEPT_TO_DEPT_INCENTIVE = 'DEPT_TO_DEPT_INCENTIVE';
export const ALERT_SYNC_HOTEL = 'ALERT_SYNC_HOTEL';
